import { env } from '@/lib/env';

/**
 * Starts the mock service worker, in development only.
 *
 * The `env.useMsw` flag is already hard-gated on `import.meta.env.PROD`, so a
 * production build cannot enable this even with `VITE_USE_MSW=true` set. That
 * matters more here than in a typical app: a mocked admin panel reports that a
 * coach was approved, and nothing was.
 *
 * `onUnhandledRequest: 'bypass'` is the whole design. Only `/admin/*` is faked;
 * Firebase Auth, `/auth/session`, `/auth/me` and the built `/trainers` endpoints
 * all go to the real network.
 */
export async function startMocks(): Promise<void> {
  if (!env.useMsw) return;

  const { setupWorker } = await import('msw/browser');
  const { handlers } = await import('@/mocks/handlers');

  const worker = setupWorker(...handlers);

  await worker.start({
    onUnhandledRequest: 'bypass',
    quiet: false,
    serviceWorker: { url: '/mockServiceWorker.js' },
  });

  console.info(
    '%c[msw] /admin/* is mocked. Auth and every other endpoint hit the real API.',
    'color:#7C3AED;font-weight:600',
  );
}
